import { api, heureAff } from "../lib/api";
import { nomCat } from "../lib/categorie";

const LE_TYPE = { match: "le match", entrainement: "l'entraînement", tournoi: "le tournoi" };

// Phrase d'intro et ligne « qui / quoi » adaptées au type de convocation.
const introType = (m) => (m.type === "entrainement"
  ? `Nous vous communiquons la convocation pour l'entraînement du ${(m.date ?? "").toLowerCase()}.`
  : `Nous vous communiquons la convocation pour ${LE_TYPE[m.type] ?? LE_TYPE.match} de ce week-end.`);
export const ligneType = (m) => {
  if (m.type === "entrainement") return `⚽️ Entraînement : ${m.club ?? ""}`;
  if (m.type === "tournoi") return `🏆 ${/^tournoi/i.test(m.adversaire ?? "") ? m.adversaire : `Tournoi : ${m.adversaire ?? ""}`} (${m.club ?? ""})`;
  return `🏟️ Match : ${m.club ?? ""} - ${m.adversaire ?? ""}`;
};

export const lienReponse = (m) => `${window.location.origin}/${m?.court || m?.id ? `?c=${m.court || m.id}` : ""}`;

const limiteTxt = (m) => (m.date_limite ? `⏳ Avant le ${m.date_limite}${m.heure_limite ? ` à ${m.heure_limite.replace(":", "h")}` : ""}` : null);

export const blocReponse = (m) => [
  "━━━━━━━━━━━━",
  "✅ *RÉPONDRE ICI (présent / absent)*",
  ...(limiteTxt(m) ? [limiteTxt(m)] : []),
  `👉 ${lienReponse(m)}`,
  "━━━━━━━━━━━━",
];

export const infosLignes = (match) => [
    `📅 Date : ${match.date ?? ""}`,
    ligneType(match),
    `📌 Adresse : ${match.adresse || match.lieu || ""}`,
    `⏰ Heure de rendez-vous : ${heureAff(match.rendez_vous)}`,
    `${match.type === "entrainement" ? "🕒" : "⚽️"} Heure de début : ${heureAff(match.heure)}`,
];

export const buildText = (match, convoques = []) =>
  [
    "Bonjour à tous,",
    introType(match),
    "",
    ...infosLignes(match),
    ...(match.type === "entrainement" ? [] : ["", `🚗 Covoiturage possible${match.covoit_heure || match.covoit_lieu ? ` : rendez-vous${match.covoit_heure ? ` à ${heureAff(match.covoit_heure)}` : ""}${match.covoit_lieu ? ` — ${match.covoit_lieu}` : ""}` : ""} (à indiquer dans la réponse : pas de voiture / places disponibles)`]),
    "",
    ...blocReponse(match),
    ...(convoques.length && match.type !== "entrainement" ? ["", `👥 Joueurs convoqués (${convoques.length}) :`, ...convoques.map((j) => `- ${nomCat(j)}`)] : []),
  ].join("\n");

const isMobile = () => /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

export const openWhatsApp = (rawText) => {
  const text = encodeURIComponent(rawText);
  if (isMobile()) window.location.href = `whatsapp://send?text=${text}`;
  else window.open(`https://api.whatsapp.com/send?text=${text}`, "_blank", "noopener,noreferrer");
};

// Numéro belge au format international pour WhatsApp : 0470 11 22 33 -> 32470112233.
export const waNumero = (tel) => {
  let d = (tel ?? "").replace(/\D/g, "");
  if (d.startsWith("00")) d = d.slice(2);
  else if (d.startsWith("0")) d = `32${d.slice(1)}`;
  return d.length >= 9 ? d : "";
};

export const openWhatsAppTo = (tel, rawText) => {
  const text = encodeURIComponent(rawText);
  const n = waNumero(tel);
  if (isMobile()) window.location.href = `whatsapp://send?phone=${n}&text=${text}`;
  else window.open(`https://api.whatsapp.com/send?phone=${n}&text=${text}`, "_blank", "noopener,noreferrer");
};

// Délai dépassé : le parent prévient le coach sur WhatsApp (numéro du coach pris dans l'encadrement).
export const messageCoach = async (match) => {
  const coach = (await api.get("/contact-coach").catch(() => null))?.data ?? {};
  const texte = [
    `Bonjour${coach.nom ? ` ${coach.nom}` : ""},`,
    `Le délai de réponse est dépassé pour la convocation${match?.date ? ` du ${match.date}` : ""}${match?.adversaire ? ` (${match.club ?? ""} - ${match.adversaire})` : ""}.`,
    "Enfant : ",
    "Présent / Absent : ",
  ].join("\n");
  if (waNumero(coach.telephone)) openWhatsAppTo(coach.telephone, texte);
  else openWhatsApp(texte);
};

